import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Funcionarios from './pages/Funcionarios';
import Usuarios from './pages/Usuarios';
import Perfil from './pages/Perfil';
import ResetPassword from './pages/ResetPassword';
import EquipoPublico from './pages/EquipoPublico';
import SupervisorDashboard from './pages/SupervisorDashboard';
import Solicitudes from './pages/Solicitudes';
import SolicitudPublica from './pages/SolicitudPublica';
import Auditoria from './pages/Auditoria';
import { AlertProvider } from './components/AlertContext';
import AlertContainer from './components/AlertContainer';

// Espacios Module
import HomeEspacios from './pages/espacios/HomeEspacios';
import AreasEspacios from './pages/espacios/AreasEspacios';
import DetalleAreaEspacios from './pages/espacios/DetalleAreaEspacios';
import ReservasEspacios from './pages/espacios/ReservasEspacios';
import LoginEspacios from './pages/espacios/LoginEspacios';

function App() {
  React.useEffect(() => {
    // Inicializar Tema desde localStorage
    const savedTheme = localStorage.getItem('app-theme') || 'dark';
    document.body.setAttribute('data-theme', savedTheme);
  }, []);

  return (
    <AlertProvider>
      <BrowserRouter>
        <AlertContainer />
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/funcionarios" element={<Funcionarios />} />
          <Route path="/usuarios" element={<Usuarios />} />
          <Route path="/auditoria" element={<Auditoria />} />
          <Route path="/perfil" element={<Perfil />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />
          <Route path="/equipo/:codigo" element={<EquipoPublico />} />
          <Route path="/supervisor" element={<SupervisorDashboard />} />
          <Route path="/solicitudes" element={<Solicitudes />} />
          <Route path="/solicitar" element={<SolicitudPublica />} />

          {/* Espacios Module */}
          <Route path="/espacios/login" element={<LoginEspacios />} />
          <Route path="/espacios" element={<HomeEspacios />} />
          <Route path="/espacios/" element={<HomeEspacios />} />
          <Route path="/espacios/home" element={<HomeEspacios />} />
          <Route path="/espacios/areas" element={<AreasEspacios />} />
          <Route path="/espacios/dashboard" element={<DetalleAreaEspacios />} />
          <Route path="/espacios/reservas" element={<ReservasEspacios />} />
        </Routes>
      </BrowserRouter>
    </AlertProvider>
  );
}

export default App;
